/**
 * ContactPage — Contact form (FormSubmit) and team address/email sidebar.
 */
import React, { useState } from 'react';
import PageHeader from './PageHeader';
import styles from './ContactPage.module.css';

const FORM_ENDPOINT = 'https://formsubmit.co/ajax/ffxrobotics@gmail.com';

function ContactPage() {
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setError('');

    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          subject: form.subject,
          message: form.message,
          _subject: `Roarbotics contact: ${form.subject || 'General inquiry'}`,
        }),
      });

      if (!res.ok) {
        throw new Error('Submission failed');
      }

      setStatus('success');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch {
      setStatus('error');
      setError('Something went wrong. Email us directly at ffxrobotics@gmail.com.');
    }
  };

  return (
    <div className={`roar-page ${styles.page}`}>
      <PageHeader
        eyebrow="Contact"
        title="Get in touch"
        lead="Questions about joining, sponsoring, or visiting the shop — send a message and we'll reply."
      />

      <div className={styles.layout}>
        <div className={styles.formPanel}>
          {status === 'success' ? (
            <div className={styles.success} role="status">
              <p className={styles.successTitle}>Message sent</p>
              <p>We&apos;ll get back to you soon.</p>
            </div>
          ) : (
            <form className={styles.form} onSubmit={handleSubmit} noValidate>
              <div className={styles.field}>
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  autoComplete="name"
                  placeholder="Your name"
                  value={form.name}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange}
                />
                <span className={styles.hint}>Only used to reply to you.</span>
              </div>

              <div className={styles.field}>
                <label htmlFor="subject">Subject</label>
                <input
                  id="subject"
                  name="subject"
                  type="text"
                  required
                  placeholder="What is this about?"
                  value={form.subject}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  placeholder="Your message"
                  value={form.message}
                  onChange={handleChange}
                />
              </div>

              {status === 'error' && (
                <p className={styles.error} role="alert">{error}</p>
              )}

              <button
                type="submit"
                className={styles.submit}
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Sending…' : 'Send message'}
              </button>
            </form>
          )}
        </div>

        <aside className={styles.sidebar}>
          <h2 className={styles.sidebarTitle}>Direct</h2>
          <p>
            <a href="mailto:ffxrobotics@gmail.com">ffxrobotics@gmail.com</a>
          </p>
          <p>
            Fairfax High School<br />
            3501 Lion Run<br />
            Fairfax, VA 22030
          </p>
          <p>
            For sponsorship details, mention &quot;Corporate sponsorship&quot; in
            your subject line. Tax-deductible gifts are processed through Fairfax
            High School (501(c)(3)).
          </p>
        </aside>
      </div>
    </div>
  );
}

export default ContactPage;
